import { useNavigate } from "react-router-dom";

import { Result, Row } from "antd";
import { ActionButton } from "@hdi-seguros/web-components.action-button";


import './index.css';

export const NotFound = () => {
    const navigate = useNavigate();

    return (
        <Row
            align='middle'
            justify='center'
            style={{ width: '100%', height: '100vh' }}
        >
            <Result
                status="404"
                title="404"
                subTitle="La pagina solicitada no existe o fue removida. Si considera que esto es un error, por favor comuniquese con el Soporte Tecnico."
                extra={
                    <ActionButton
                        className='btn-principal-barbuss'
                        label="Volver al Inicio"
                        onClick={() => navigate('/')}
                    />
                }
            />
        </Row>
    )
}
